<h1 mat-dialog-title>{{ 'feedbackdialog.title' | translate }}</h1>
<div mat-dialog-content>
    <div class="example-form" [formGroup]="feedbackForm">
        <p class="dialog-subtitle">{{ 'feedbackdialog.disclaimer' | translate }}</p>
        <mat-form-field class="example-full-width">
            <mat-label>{{ 'feedbackdialog.mailFrom' | translate }}</mat-label>
            <input matInput required formControlName="mailFrom">
            <mat-error *ngIf="feedbackForm.get('mailFrom')?.hasError('required')">
                {{ 'feedbackdialog.requiredError' | translate }}
            </mat-error>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>{{ 'feedbackdialog.subject' | translate }}</mat-label>
            <input matInput required formControlName="mailSubject">
            <mat-error *ngIf="feedbackForm.get('mailSubject')?.hasError('required')">
                {{ 'feedbackdialog.requiredError' | translate }}
            </mat-error>
        </mat-form-field>

        <ng-container *ngIf="!isCaseForm">
            <mat-form-field class="example-full-width">
                <mat-label>{{ 'feedbackdialog.systemOrComponent' | translate }}</mat-label>
                <input matInput required formControlName="mailSystemOrComponent">
                <mat-error *ngIf="feedbackForm.get('mailSystemOrComponent')?.hasError('required')">
                    {{ 'feedbackdialog.atLeastOneRequiredError' | translate }}
                </mat-error>
            </mat-form-field>
        </ng-container>

        <div *ngIf="isCaseForm" class="case-container">
            <mat-form-field class="example-full-width">
                <mat-label>{{ 'feedbackdialog.system' | translate }}</mat-label>
                <input matInput [required]="isCaseForm && !feedbackForm.get('caseSerial')?.value" formControlName="caseSystem">
            </mat-form-field>

            <mat-form-field class="example-full-width">
                <mat-label>{{ 'feedbackdialog.serial' | translate }}</mat-label>
                <input matInput [required]="isCaseForm && !feedbackForm.get('caseSystem')?.value" formControlName="caseSerial">
            </mat-form-field>
            <span *ngIf="feedbackForm.hasError('atLeastOneRequired') && feedbackForm.touched" class="error-message">
                {{ 'feedbackdialog.atLeastOneRequiredError' | translate }}
            </span>
        </div>

        <mat-form-field class="example-full-width">
            <mat-label>{{ 'feedbackdialog.feedbacktext' | translate }}</mat-label>
            <textarea matInput rows="10" placeholder="{{'feedbacktext.placeholder' | translate}}" required
                      formControlName="mailBody"></textarea>
            <mat-error *ngIf="feedbackForm.get('mailBody')?.hasError('required')">
                {{ 'feedbackdialog.requiredError' | translate }}
            </mat-error>

            <mat-error *ngIf="feedbackForm.get('mailBody')?.hasError('minlength')">
                {{ 'feedbackdialog.minLengthError' | translate }}
            </mat-error>
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions style="justify-content: space-between">
    <button mat-raised-button color="primary" (click)="onNoClick()">{{ 'buttons.cancel' | translate }}</button>
    <button mat-raised-button color="primary" (click)="getFeedbackData()"
            cdkFocusInitial>{{ 'buttons.sendFeedback' | translate }}
    </button>
</div>
